import React from 'react'
import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'
import Paper from '@mui/material/Paper'
import { createUseStyles } from 'react-jss'
import { useTranslation } from 'react-i18next'
import {
  CustomerAddress,
  Footer,
  Header,
  Payment,
  Subject,
  TableBody,
  TableHeader,
  theme
} from '../../document/Document'
import { baseDocument } from '../../../utils/constants/misc'

const useStyles = createUseStyles(theme)

const Quote = ({ document_param: quote, company_param: company, logo_param: logo, settings_param: settings }) => {
  const customer = quote.customer
  const classes = useStyles()
  const { t } = useTranslation()

  const References = () => {
    if (quote) {
      const date = new Date(quote.quote_date)
      const dateVal = new Date(quote.validity_date)

      const dateConv = t('dates.localisedDate', { date: date })
      const dateValConv = t('dates.localisedDate', { date: dateVal })

      return (
        <>
          <Box className={classes.rightContainer}>
            <Typography className={classes.boldWithSpace}>Référence devis</Typography>
            <Typography className={classes.address}>{quote.quote_number}</Typography>
          </Box>
          <Box className={classes.rightContainer}>
            <Typography className={classes.bold}>Date de création {dateConv}</Typography>
          </Box>
          <Box className={classes.rightContainerNoSpaceBottom}>
            <Typography className={classes.bold}>{`Valable jusqu'au ${dateValConv}`}</Typography>
          </Box>
        </>
      )
    }
  }

  const QuotePaymentNote = () => {
    return (
      <Box className={classes.mt}>
        <Typography className={classes.conditions}>
          Merci de nous retourner ce devis signé avec la mention "Bon pour accord".
        </Typography>
      </Box>
    )
  }

  return (
    <Paper className={classes.paper}>
      <Box className={classes.page}>
        <Header classes={classes} documentTitle={'DEVIS'} logo={logo} />
        <References />
        <CustomerAddress customer={customer} company={company} classes={classes} />
        <Subject document={quote} classes={classes} />
        <TableHeader headers={baseDocument} classes={classes} />
        <TableBody headers={baseDocument} lines={quote.lines} total={quote.total_amount_net} classes={classes} />
        <Payment classes={classes} customer={customer} settings={settings} />
        <QuotePaymentNote />
        <Footer company={company} classes={classes} />
      </Box>
    </Paper>
  )
}

export default Quote
